import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { EditPersonalDataService } from '../services/edit-personal-data.service';
import { UserDetails } from '../models/UserDetails';
import { Aggregate } from '../models/Aggregate';
import { Client } from '../models/Client';
import { Person } from '../models/Person';
import { Address } from '../models/Address';
import { BalancingProcessDetails } from '../models/BalancingProcessDetails';
import { of, Subscription } from 'rxjs';
import { ActivatedRoute, Router } from '@angular/router';
import { map, switchMap } from 'rxjs/internal/operators';
import { CountyDTO } from '../../shared/models/CountyDTO';
import { CityDTO } from '../../shared/models/CityDTO';
import { AddressService } from '../../shared/services/address.service';
import { ToastrService } from 'ngx-toastr';
import { DocumentService } from 'src/app/shared/service/document.service';
import { InternalDocument } from '../../../shared/model/internal-document';
import Swal from 'sweetalert2';
import {catchError} from 'rxjs/operators';

@Component({
  selector: 'app-view-personal-data',
  templateUrl: './view-personal-data.component.html',
  styleUrls: ['./view-personal-data.component.scss']
})
export class ViewPersonalDataComponent implements OnInit, OnDestroy {

  public counties: CountyDTO[] = [];
  public cities: CityDTO[] = [];
  public citiesCorrespondence: CityDTO[] = [];
  // @Input() isFormSubmitAttempt: boolean;
  // @Input() isContractChange: boolean;
  // @Input() fromSupplier: boolean;
  // @Input() set isEditable(value: boolean) {
  //   this.editable = value;
  //   if (!this.editable) {
  //     this.accountForm.disable();
  //   }
  // }
  @Input() set person(value: any) {
    if (!value) {
      this.initializeFormFields();
      return;
    }
    const aggregate: Aggregate = value.aggregateDTO;
    const client: Client = value.clientDTO;
    const person: Person = value.personDTO;
    const address: Address = value.addressDTO;
    const correspondenceAddress: Address = value.correspondenceAddressDTO;
    const balancingProcessDetails: BalancingProcessDetails = value.balancingProcessDetailsDTO;

    this.userId = value.id;
    this.identityDocument = value.identityDocument;
    this.clientId = client.id;

    this.accountForm.patchValue({
      aggregationName: aggregate.aggregationName,
      aggregationPhoneNumber: aggregate.aggregationPhoneNumber,
      aggregationFax: aggregate.aggregationFax,
      aggregationCui: aggregate.aggregationCui,
      aggregationEmail: aggregate.aggregationEmail,
      aggregationJuridicalForm: aggregate.aggregationJuridicalForm,
      aggregationOnrcRegistrationNumber: aggregate.aggregationOnrcRegistrationNumber,
      aggregationMobilePhoneNumber: aggregate.aggregationMobilePhoneNumber,
      aggregationPersonName: aggregate.aggregationPersonName,
      aggregationPersonSurname: aggregate.aggregationPersonSurname,
      aggregationPersonCnp: aggregate.aggregationPersonCnp,
      aggregatorClientType: aggregate.aggregatorClientType,
      isAggregate: client.isAggregate,
      isPre: client.isPre,
      isProsumer: client.isProsumer,
      isUninterruptible: client.isUninterruptible,
      isVulnerable: client.isVulnerable,
      isElectricalEnergyClient: client.isElectricalEnergyClient,
      isNaturalGasClient: client.isNaturalGasClient,
      isAutoSupplier: client.autosupplier,
      cnp: person.cnp,
      email: value.email,
      extra: person.extra,
      idType: person.idType,
      citizenshipType: person.citizenshipType,
      idEmitter: person.idEmitter,
      idNumber: person.idNumber,
      idValidFrom: person.idValidFrom,
      idValidTo: person.idValidTo,
      lastName: person.lastName,
      phoneNumber: person.phoneNumber,
      firstName: person.firstName,
      idSeries: person.idSeries,
      city: address.city,
      extendedAddress: address.extendedAddress,
      postalCode: address.postalCode,
      county: address.county,
      streetNumber: address.streetNumber,
      streetName: address.streetName,
      block: address.block,
      floor: address.floor,
      apartment: address.apartment,
      correspondenceCity: correspondenceAddress.city,
      correspondenceExtendedAddress: correspondenceAddress.extendedAddress,
      correspondencePostalCode: correspondenceAddress.postalCode,
      correspondenceCounty: correspondenceAddress.county,
      correspondenceStreetNumber: correspondenceAddress.streetNumber,
      correspondenceStreetName: correspondenceAddress.streetName,
      correspondenceBlock: correspondenceAddress.block,
      correspondenceFloor: correspondenceAddress.floor,
      correspondenceApartment: correspondenceAddress.apartment,
      balancingProcessName: balancingProcessDetails.name,
      balancingProcessJuridicalForm: balancingProcessDetails.juridicalForm,
      balancingProcessCui: balancingProcessDetails.cui,
      balancingProcessRegistrationNumber: balancingProcessDetails.registrationNumber,
      balancingProcessPhoneNumber: balancingProcessDetails.phoneNumber,
      balancingProcessMobilePhoneNumber: balancingProcessDetails.mobilePhoneNumber,
      balancingProcessFax: balancingProcessDetails.fax,
      balancingProcessEmail: balancingProcessDetails.email,
      balancingProcessHasDelegatedPRE: balancingProcessDetails.hasDelegatedPRE,
      balancingProcessHasOtherPRE: balancingProcessDetails.hasOtherPRE,
      balancingProcessPersonName: balancingProcessDetails.personName,
      balancingProcessPersonSurname: balancingProcessDetails.personSurname,
      balancingProcessPersonCnp: balancingProcessDetails.personCnp,
      balancingProcessPreType: balancingProcessDetails.preType,
    });

    this.cities = [];
    this.citiesCorrespondence = [];
    this.addressService.getCities(this.accountForm.get('county').value)
      .subscribe((cities: CityDTO[]) => {
        this.cities = cities;
      });
    this.addressService.getCities(this.accountForm.get('correspondenceCounty').value)
      .subscribe((citiesCorrespondence: CityDTO[]) => {
        this.citiesCorrespondence = citiesCorrespondence;
      });
  }

  // @Output() formValid = new EventEmitter<boolean>();

  public settings = {
    columns: {
      img: {
        title: 'Image',
        type: 'html',
      },
      file_name: {
        title: 'File Name'
      },
      url: {
        title: 'Url',
      },
    },
  };
  public accountForm: FormGroup;
  public permissionForm: FormGroup;
  public userDetails: any;
  public errorMessage: string;
  public isSameAddress = false;
  public editable = true;
  public identityDocument: InternalDocument;
  private subscriptions: Subscription[] = [];
  public foreignCitizen = 'Cetatean strain';
  public romanianCitizen = 'Cetatean roman';
  public yes = 'DA';
  public no = 'NU';
  public cnp = 'CNP';
  public idCard = 'Carte de identitate';
  public passport = 'Pasaport';
  public residenceCard = 'Carte de rezidenta';
  public identificationNumber = 'Numar de identificare';

  private userId: number;
  private clientId: number;
  private routeDataSub: Subscription;
  private keycloakUserProfile: any;

  constructor(
    public documentService: DocumentService,
    private addressService: AddressService,
    private formBuilder: FormBuilder,
    private route: ActivatedRoute,
    private toastrService: ToastrService,
    private router: Router,
    private personalDataService: EditPersonalDataService
  ) {
    this.editable = false;
    this.createAccountForm();
    // this.createAccountFormListeners();
    // this.createPermissionForm();
    this.userDetails = {} as any;
  }

  createAccountForm(): void {
    this.accountForm = this.formBuilder.group({
      // person
      firstName: ['', [Validators.required, Validators.minLength(2)]],
      lastName: ['', [Validators.required, Validators.minLength(2)]],
      phoneNumber: ['', [Validators.required, Validators.minLength(2)]],
      clientType: [{
        value: 'Casnic',
        disabled: true
      }, [Validators.required]],
      email: ['', [Validators.required]],
      extra: [''],
      cnp: ['', [Validators.required, Validators.minLength(13), Validators.maxLength(13), Validators.pattern('^[0-9]*$')]],
      idSeries: ['', [Validators.required]],
      idEmitter: ['', [Validators.required]],
      citizenshipType: ['', [Validators.required]],
      idType: ['', [Validators.required]],
      idNumber: ['', [Validators.required]],
      // toDo format below values for input date type compatibility
      idValidFrom: ['', [Validators.required]],
      idValidTo: ['', [Validators.required]],
      //  address
      county: ['', [Validators.required]],
      city: ['', [Validators.required]],
      streetName: ['', [Validators.required]],
      streetNumber: ['', [Validators.required]],
      block: [''],
      apartment: [''],
      floor: [''],
      postalCode: ['', [Validators.required]],
      // correspondenceAddress
      correspondenceCounty: ['', [Validators.required]],
      correspondenceCity: ['', [Validators.required]],
      correspondenceStreetName: ['', [Validators.required]],
      correspondenceStreetNumber: ['', [Validators.required]],
      correspondenceBlock: [''],
      correspondenceFloor: [''],
      correspondenceApartment: [''],
      correspondencePostalCode: ['', [Validators.required]],
      //  client
      isAutoSupplier: [false],
      isAggregate: [false],
      isElectricalEnergyClient: [false],
      isNaturalGasClient: [false],
      isPre: [false],
      isProsumer: [false],
      isUninterruptible: [false],
      isVulnerable: [false],
      // aggregationDetails
      aggregationPersonName: [{ value: '', disabled: true }, [Validators.required]],
      aggregationPersonSurname: [{ value: '', disabled: true }, [Validators.required]],
      aggregationPersonCnp: [{
        value: '',
        disabled: true
      }, [Validators.required, Validators.minLength(13), Validators.maxLength(13), Validators.pattern('^[0-9]*$')]],
      aggregatorClientType: [{ value: '', disabled: true }, [Validators.required]],
      //
      aggregationName: [{ value: '', disabled: true }, [Validators.required]],
      aggregationJuridicalForm: [{ value: '', disabled: true }, [Validators.required]],
      aggregationCui: [{ value: '', disabled: true }, [Validators.required]],
      aggregationOnrcRegistrationNumber: [{ value: '', disabled: true }, [Validators.required]],
      aggregationPhoneNumber: [{ value: '', disabled: true }, [Validators.required]],
      aggregationMobilePhoneNumber: [{ value: '', disabled: true }, [Validators.required]],
      aggregationFax: [{ value: '', disabled: true }, [Validators.required]],
      aggregationEmail: [{ value: '', disabled: true }, [Validators.required]],
      // balancingProcessDetails
      balancingProcessPersonName: [{ value: '', disabled: true }, [Validators.required]],
      balancingProcessPersonSurname: [{ value: '', disabled: true }, [Validators.required]],
      balancingProcessPersonCnp: [{ value: '', disabled: true }, [Validators.required, Validators.minLength(13),
      Validators.maxLength(13), Validators.pattern('^[0-9]*$')]],
      balancingProcessPreType: [{ value: '', disabled: true }, [Validators.required]],
      //
      balancingProcessName: [{ value: '', disabled: true }, [Validators.required]],
      balancingProcessJuridicalForm: [{ value: '', disabled: true }, [Validators.required]],
      balancingProcessCui: [{ value: '', disabled: true }, [Validators.required]],
      balancingProcessRegistrationNumber: [{ value: '', disabled: true }, [Validators.required]],
      balancingProcessPhoneNumber: [{ value: '', disabled: true }, [Validators.required]],
      balancingProcessMobilePhoneNumber: [{ value: '', disabled: true }, [Validators.required]],
      balancingProcessFax: [{ value: '', disabled: true }, [Validators.required]],
      balancingProcessEmail: [{ value: '', disabled: true }, [Validators.required]],
      balancingProcessHasDelegatedPRE: [false],
      balancingProcessHasOtherPRE: [false],
    });

    this.accountForm.disable();
  }

  createAccountFormListeners(): void {
    this.subscriptions.push(
      this.accountForm.get('county').valueChanges.subscribe(value => this.updateCorrespondenceCounty(value))
    );
    this.subscriptions.push(
      this.accountForm.get('city').valueChanges.subscribe(value => this.updateCorrespondenceCity(value))
    );
    this.subscriptions.push(
      this.accountForm.get('streetName').valueChanges.subscribe(value => this.updateCorrespondenceStreetName(value))
    );
    this.subscriptions.push(
      this.accountForm.get('streetNumber').valueChanges.subscribe(value => this.updateCorrespondenceStreetNumber(value))
    );
    this.subscriptions.push(
      this.accountForm.get('block').valueChanges.subscribe(value => this.updateCorrespondenceBlock(value))
    );
    this.subscriptions.push(
      this.accountForm.get('apartment').valueChanges.subscribe(value => this.updateCorrespondenceApartment(value))
    );
    this.subscriptions.push(
      this.accountForm.get('floor').valueChanges.subscribe(value => this.updateCorrespondenceFloor(value))
    );
    this.subscriptions.push(
      this.accountForm.get('postalCode').valueChanges.subscribe(value => this.updateCorrespondencePostalCode(value))
    );
    this.subscriptions.push(
      this.accountForm.get('idType').valueChanges.subscribe(idType => {
        if (idType === 'CNP') {
          this.accountForm.get('cnp').setValidators([Validators.required, Validators.minLength(13),
          Validators.maxLength(13), Validators.pattern('^[0-9]*$')]);
        } else {
          this.accountForm.get('cnp').clearValidators();
          this.accountForm.get('cnp').setValidators([Validators.required]);
        }
        this.accountForm.controls.cnp.updateValueAndValidity({ onlySelf: true, emitEvent: false });
      }
      ));
  }

  createPermissionForm(): void {
    this.permissionForm = this.formBuilder.group({});
  }

  ngOnInit(): void {
    /*const userProfile = localStorage.getItem('userProfile');
    if (userProfile) {
      this.keycloakUserProfile = JSON.parse(userProfile);
    }*/

    this.addressService.getCounties().subscribe(counties => {
      this.counties = counties;
    });

    this.accountForm.disable();

    /*this.routeDataSub = this.route
      .paramMap
      .pipe(
        map(value => {
          if (window.history.state.editable != null) {
            this.editable = !!window.history.state.editable;
            if (!this.editable) {
              this.accountForm.disable();
            }
          }
          return value;
        }),
        switchMap(
          () => !(this.isContractChange && localStorage.getItem('fromSupplier') === 'true')
            && !this.userId ? this.personalDataService.getPersonalData() : of(null)),
        catchError(() => of(null))
      ).subscribe((userDetails: UserDetails) => this.initializeFormFields(userDetails));*/
  }


  initializeFormFields(): void {
    this.personalDataService.getPersonalData().subscribe((userDetails: UserDetails) => {
      if (userDetails) {
        const {
          email,
          personDTO,
          addressDTO,
          correspondenceAddressDTO,
          clientDTO,
          aggregateDTO,
          balancingProcessDetailsDTO,
          identityDocument
        } = userDetails;
        this.userDetails = {...personDTO, ...addressDTO, ...clientDTO, ...aggregateDTO, email};
        this.identityDocument = identityDocument;
        if (userDetails) {
          this.userId = userDetails.id;
        }
        if (clientDTO) {
          // clientDTO.isElectricalEnergyClient = true; // pentru testare
          this.clientId = clientDTO.id;
          this.accountForm.controls.isElectricalEnergyClient.setValue(clientDTO.isElectricalEnergyClient);
          if (clientDTO.autosupplier) {
            this.accountForm.controls.isAutoSupplier.setValue(clientDTO.autosupplier);
          } else {
            this.accountForm.controls.isAutoSupplier.setValue(false);
          }
        }
        if (this.userDetails.citizenshipType === 'Cetatean roman') {
          this.userDetails.citizenshipType = 'CETATEAN_ROMAN';
        } else if (this.userDetails.citizenshipType === 'Cetatean strain') {
          this.userDetails.citizenshipType = 'CETATEAN_STRAIN';
        }
        Object.keys(this.accountForm.controls).forEach(
          key => {
            if (this.userDetails[key]) {
              this.accountForm.controls[key].patchValue(this.userDetails[key]);
            }
          }
        );
        if (correspondenceAddressDTO) {
          this.accountForm.patchValue({
            correspondenceCounty: correspondenceAddressDTO.county,
            correspondenceCity: correspondenceAddressDTO.city,
            correspondenceStreetName: correspondenceAddressDTO.streetName,
            correspondenceStreetNumber: correspondenceAddressDTO.streetNumber,
            correspondenceBlock: correspondenceAddressDTO.block,
            correspondenceFloor: correspondenceAddressDTO.floor,
            correspondenceApartment: correspondenceAddressDTO.apartment,
            correspondencePostalCode: correspondenceAddressDTO.postalCode
          });
          this.addressService.getCities(this.accountForm.get('correspondenceCounty').value)
            .subscribe((citiesCorrespondence: CityDTO[]) => {
              this.citiesCorrespondence = citiesCorrespondence;
            });
        }

        if (balancingProcessDetailsDTO) {
          this.accountForm.patchValue({
            balancingProcessName: balancingProcessDetailsDTO.name,
            balancingProcessJuridicalForm: balancingProcessDetailsDTO.juridicalForm,
            balancingProcessCui: balancingProcessDetailsDTO.cui,
            balancingProcessRegistrationNumber: balancingProcessDetailsDTO.registrationNumber,
            balancingProcessPhoneNumber: balancingProcessDetailsDTO.phoneNumber,
            balancingProcessMobilePhoneNumber: balancingProcessDetailsDTO.mobilePhoneNumber,
            balancingProcessFax: balancingProcessDetailsDTO.fax,
            balancingProcessEmail: balancingProcessDetailsDTO.email,
            balancingProcessHasDelegatedPRE: balancingProcessDetailsDTO.hasDelegatedPRE,
            balancingProcessHasOtherPRE: balancingProcessDetailsDTO.hasOtherPRE,
            balancingProcessPersonName: balancingProcessDetailsDTO.personName,
            balancingProcessPersonSurname: balancingProcessDetailsDTO.personSurname,
            balancingProcessPersonCnp: balancingProcessDetailsDTO.personCnp,
            balancingProcessPreType: balancingProcessDetailsDTO.preType
          });
        }

        if (this.editable) {
          this.setIsNaturalGasClient();
          this.setIsElectricalEnergyClient();
        }

        this.cities = [];
        this.citiesCorrespondence = [];
        if (this.accountForm.get('county').value) {
          this.addressService.getCities(this.accountForm.get('county').value)
            .subscribe((cities: CityDTO[]) => {
              this.cities = cities;
            });
        }
      }
    });
  }

  setIsElectricalEnergyClient(): void {
    const isElectricalEnergyClient = this.accountForm.value.isElectricalEnergyClient;
    this.accountForm.controls.isElectricalEnergyClient.setValue(isElectricalEnergyClient);
    const isAggregate = isElectricalEnergyClient && this.accountForm.value.isAggregate;
    const hasDelegatedPRE = isElectricalEnergyClient && this.accountForm.value.balancingProcessHasDelegatedPRE;
    const hasOtherPRE = isElectricalEnergyClient && this.accountForm.value.balancingProcessHasOtherPRE;
    this.setIsAggregate(isAggregate);
    this.hasBalanceProcessDetails(isElectricalEnergyClient);
    this.setHasDelegatedPRE(hasDelegatedPRE);
    this.setHasOtherPRE(hasOtherPRE);
  }

  setIsNaturalGasClient(): void {
    const isNaturalGasClient = this.accountForm.value.isNaturalGasClient;
    this.accountForm.controls.isNaturalGasClient.setValue(isNaturalGasClient);
  }

  hasBalanceProcessDetails(val: boolean): void {
    if (!val) {
      this.accountForm.controls.balancingProcessPersonName.disable();
      this.accountForm.controls.balancingProcessPersonSurname.disable();
      this.accountForm.controls.balancingProcessPersonCnp.disable();
      this.accountForm.controls.balancingProcessName.disable();
      this.accountForm.controls.balancingProcessJuridicalForm.disable();
      this.accountForm.controls.balancingProcessCui.disable();
      this.accountForm.controls.balancingProcessRegistrationNumber.disable();
      this.accountForm.controls.balancingProcessPhoneNumber.disable();
      this.accountForm.controls.balancingProcessMobilePhoneNumber.disable();
      this.accountForm.controls.balancingProcessFax.disable();
      this.accountForm.controls.balancingProcessEmail.disable();
    }
  }

  setCitizenshipType(citizenshipType: string): void {
    if (citizenshipType === 'Cetatean roman') {
      this.accountForm.controls.citizenshipType.setValue('CETATEAN_ROMAN');
    } else if (citizenshipType === 'Cetatean strain') {
      this.accountForm.controls.citizenshipType.setValue('CETATEAN_STRAIN');
    }
  }

  setAutoSupplier(autoSupplierType: boolean): void {
    this.accountForm.controls.isAutoSupplier.setValue(autoSupplierType);
  }

  onDisplayRequiredField(field: string): any {
    return {
      'label-error': !this.isFieldValid(field),
    };
  }

  isFieldValid(field: string): boolean {
    return !this.accountForm.controls[field].invalid;
  }

  setIsProsumer(value: boolean): void {
    this.accountForm.controls.isProsumer.setValue(value);
  }

  setIsVulnerable(value: boolean): void {
    this.accountForm.controls.isVulnerable.setValue(value);
  }

  setIsUninterruptible(value: boolean): void {
    this.accountForm.controls.isUninterruptible.setValue(value);
  }

  setHasOtherPRE(value: boolean): void {
    this.accountForm.controls.balancingProcessHasOtherPRE.setValue(value);
    if (value === true) {
      this.accountForm.controls.balancingProcessPreType.enable();
      if (this.accountForm.controls.balancingProcessPreType.value === 'PERSOANA_JURIDICA') {
        this.enableBalancingPJPre();
      } else if (this.accountForm.controls.balancingProcessPreType.value === 'PERSOANA_FIZICA') {
        this.enableBalancingPFPre();
      }
    } else {
      if (!this.accountForm.value.balancingProcessHasDelegatedPRE) {
        this.accountForm.controls.balancingProcessPreType.disable();
        this.disableBalancingPJPre();
        this.disableBalancingPFPre();
      }
    }
  }

  disableBalancingPFPre(): void {
    this.accountForm.controls.balancingProcessName.disable();
    this.accountForm.controls.balancingProcessJuridicalForm.disable();
    this.accountForm.controls.balancingProcessCui.disable();
    this.accountForm.controls.balancingProcessRegistrationNumber.disable();
    this.accountForm.controls.balancingProcessPhoneNumber.disable();
    this.accountForm.controls.balancingProcessMobilePhoneNumber.disable();
    this.accountForm.controls.balancingProcessFax.disable();
    this.accountForm.controls.balancingProcessEmail.disable();
  }

  disableBalancingPJPre(): void {
    this.accountForm.controls.balancingProcessPersonName.disable();
    this.accountForm.controls.balancingProcessPersonSurname.disable();
    this.accountForm.controls.balancingProcessPersonCnp.disable();
  }

  setHasDelegatedPRE(value: boolean): void {
    this.accountForm.controls.balancingProcessHasDelegatedPRE.setValue(value);
    if (value === true) {
      this.accountForm.controls.balancingProcessPreType.enable();
      if (this.accountForm.controls.balancingProcessPreType.value === 'PERSOANA_JURIDICA') {
        this.enableBalancingPJPre();
      } else if (this.accountForm.controls.balancingProcessPreType.value === 'PERSOANA_FIZICA') {
        this.enableBalancingPFPre();
      }
    } else {
      if (!this.accountForm.value.balancingProcessHasOtherPRE) {
        this.accountForm.controls.balancingProcessPreType.disable();
        this.disableBalancingPJPre();
        this.disableBalancingPFPre();
      }
    }
  }

  toggleSameAddress(): void {
    this.isSameAddress = !this.isSameAddress;

    if (this.isSameAddress) {
      this.citiesCorrespondence = [];
      this.addressService.getCities(this.accountForm.get('county').value).subscribe(data => {
        this.citiesCorrespondence = data;
      });
      const formData = this.accountForm.value;
      this.accountForm.patchValue({
        correspondenceCounty: formData.county,
        correspondenceCity: formData.city,
        correspondenceStreetName: formData.streetName,
        correspondenceStreetNumber: formData.streetNumber,
        correspondenceBlock: formData.block,
        correspondenceFloor: formData.floor,
        correspondenceApartment: formData.apartment,
        correspondencePostalCode: formData.postalCode,
      });
      this.accountForm.controls.correspondenceStreetName.disable();
      this.accountForm.controls.correspondenceStreetNumber.disable();
      this.accountForm.controls.correspondenceApartment.disable();
      this.accountForm.controls.correspondenceBlock.disable();
      this.accountForm.controls.correspondenceFloor.disable();
      this.accountForm.controls.correspondencePostalCode.disable();
      this.accountForm.controls.correspondenceCounty.disable();
      this.accountForm.controls.correspondenceCity.disable();
    } else {
      this.accountForm.controls.correspondenceStreetName.enable();
      this.accountForm.controls.correspondenceStreetNumber.enable();
      this.accountForm.controls.correspondenceApartment.enable();
      this.accountForm.controls.correspondenceBlock.enable();
      this.accountForm.controls.correspondenceFloor.enable();
      this.accountForm.controls.correspondencePostalCode.enable();
      this.accountForm.controls.correspondenceCounty.enable();
      this.accountForm.controls.correspondenceCity.enable();
    }
  }

  onAggregatorType(value: string): void {
    if (this.accountForm.controls.aggregatorClientType.disabled) {
      this.accountForm.controls.aggregatorClientType.enable();
    }
    if (value === 'Persoana fizica') {
      this.enablePFAggregator();
      this.disablePFAggregator();
      this.accountForm.controls.aggregatorClientType.setValue('PERSOANA_FIZICA');
    } else if (value === 'Persoana juridica') {
      this.disablePJAggregator();
      this.enablePJAggregator();
      this.accountForm.controls.aggregatorClientType.setValue('PERSOANA_JURIDICA');
    }
  }

  enableBalancingPFPre(): void {
    this.accountForm.controls.balancingProcessPersonName.enable();
    this.accountForm.controls.balancingProcessPersonSurname.enable();
    this.accountForm.controls.balancingProcessPersonCnp.enable();
  }

  enableBalancingPJPre(): void {
    this.accountForm.controls.balancingProcessName.enable();
    this.accountForm.controls.balancingProcessJuridicalForm.enable();
    this.accountForm.controls.balancingProcessCui.enable();
    this.accountForm.controls.balancingProcessRegistrationNumber.enable();
    this.accountForm.controls.balancingProcessPhoneNumber.enable();
    this.accountForm.controls.balancingProcessMobilePhoneNumber.enable();
    this.accountForm.controls.balancingProcessFax.enable();
    this.accountForm.controls.balancingProcessEmail.enable();
  }

  enablePFAggregator(): void {
    this.accountForm.controls.aggregationPersonName.enable();
    this.accountForm.controls.aggregationPersonSurname.enable();
    this.accountForm.controls.aggregationPersonCnp.enable();
  }

  disablePJAggregator(): void {
    this.accountForm.controls.aggregationPersonName.disable();
    this.accountForm.controls.aggregationPersonSurname.disable();
    this.accountForm.controls.aggregationPersonCnp.disable();
  }

  enablePJAggregator(): void {
    this.accountForm.controls.aggregationName.enable();
    this.accountForm.controls.aggregationJuridicalForm.enable();
    this.accountForm.controls.aggregationCui.enable();
    this.accountForm.controls.aggregationOnrcRegistrationNumber.enable();
    this.accountForm.controls.aggregationPhoneNumber.enable();
    this.accountForm.controls.aggregationMobilePhoneNumber.enable();
    this.accountForm.controls.aggregationFax.enable();
    this.accountForm.controls.aggregationEmail.enable();
  }

  disablePFAggregator(): void {
    this.accountForm.controls.aggregationName.disable();
    this.accountForm.controls.aggregationJuridicalForm.disable();
    this.accountForm.controls.aggregationCui.disable();
    this.accountForm.controls.aggregationOnrcRegistrationNumber.disable();
    this.accountForm.controls.aggregationPhoneNumber.disable();
    this.accountForm.controls.aggregationMobilePhoneNumber.disable();
    this.accountForm.controls.aggregationFax.disable();
    this.accountForm.controls.aggregationEmail.disable();
  }

  onBalancingProcessPreType(value: string): void {
    if (this.accountForm.controls.balancingProcessPreType.disabled) {
      this.accountForm.controls.balancingProcessPreType.enable();
    }
    if (value === 'Persoana fizica') {
      this.enableBalancingPFPre();
      this.disableBalancingPFPre();
      this.accountForm.controls.balancingProcessPreType.setValue('PERSOANA_FIZICA');
    } else if (value === 'Persoana juridica') {
      this.disableBalancingPJPre();
      this.enableBalancingPJPre();
      this.accountForm.controls.balancingProcessPreType.setValue('PERSOANA_JURIDICA');
    }
  }

  setIsAggregate(value: boolean): void {
    this.accountForm.controls.isAggregate.setValue(value);
    if (value === true) {
      this.accountForm.controls.aggregatorClientType.enable();
      if (this.accountForm.controls.aggregatorClientType.value === 'PERSOANA_FIZICA') {
        this.enablePFAggregator();
      } else if (this.accountForm.controls.aggregatorClientType.value === 'PERSOANA_JURIDICA') {
        this.enablePJAggregator();
      }
    } else {
      this.accountForm.controls.aggregatorClientType.disable();
      this.disablePFAggregator();
      this.disablePJAggregator();
    }
  }

  createDataFromForm(): any {
    const formData = this.accountForm.getRawValue();

    const aggregateDTO: Aggregate = {
      aggregationPersonName: formData.aggregationPersonName,
      aggregationPersonSurname: formData.aggregationPersonSurname,
      aggregationPersonCnp: formData.aggregationPersonCnp,
      aggregatorClientType: formData.aggregatorClientType,
      aggregationName: formData.aggregationName,
      aggregationPhoneNumber: formData.aggregationPhoneNumber,
      aggregationFax: formData.aggregationFax,
      aggregationCui: formData.aggregationCui,
      aggregationEmail: formData.aggregationEmail,
      aggregationJuridicalForm: formData.aggregationJuridicalForm,
      aggregationOnrcRegistrationNumber: formData.aggregationOnrcRegistrationNumber,
      aggregationMobilePhoneNumber: formData.aggregationMobilePhoneNumber
    };

    const clientDTO: Client = {
      id: this.clientId,
      isAggregate: formData.isAggregate,
      isPre: formData.isPre,
      isProsumer: formData.isProsumer,
      isUninterruptible: formData.isUninterruptible,
      isVulnerable: formData.isVulnerable,
      isElectricalEnergyClient: formData.isElectricalEnergyClient,
      isNaturalGasClient: formData.isNaturalGasClient,
      autosupplier: formData.isAutoSupplier
    };

    const personDTO: Person = {
      cnp: formData.cnp,
      extra: formData.extra,
      idType: formData.idType,
      citizenshipType: formData.citizenshipType,
      idEmitter: formData.idEmitter,
      idNumber: formData.idNumber,
      idValidFrom: formData.idValidFrom,
      idValidTo: formData.idValidTo,
      lastName: formData.lastName,
      phoneNumber: formData.phoneNumber,
      firstName: formData.firstName,
      idSeries: formData.idSeries
    };

    const addressDTO: Address = {
      city: formData.city,
      extendedAddress: formData.extendedAddress,
      postalCode: formData.postalCode,
      county: formData.county,
      streetNumber: formData.streetNumber,
      streetName: formData.streetName,
      block: formData.block,
      floor: formData.floor,
      apartment: formData.apartment
    };

    console.log('addressDTO = ' + JSON.stringify(addressDTO));

    const correspondenceAddressDTO: Address = this.isSameAddress ? addressDTO : {
      city: formData.correspondenceCity,
      extendedAddress: formData.correspondenceExtendedAddress,
      postalCode: formData.correspondencePostalCode,
      county: formData.correspondenceCounty,
      streetNumber: formData.correspondenceStreetNumber,
      streetName: formData.correspondenceStreetName,
      block: formData.correspondenceBlock,
      floor: formData.correspondenceFloor,
      apartment: formData.correspondenceApartment
    };

    const balancingProcessDetailsDTO: BalancingProcessDetails = {
      name: formData.balancingProcessName,
      juridicalForm: formData.balancingProcessJuridicalForm,
      cui: formData.balancingProcessCui,
      registrationNumber: formData.balancingProcessRegistrationNumber,
      phoneNumber: formData.balancingProcessPhoneNumber,
      mobilePhoneNumber: formData.balancingProcessMobilePhoneNumber,
      fax: formData.balancingProcessFax,
      email: formData.balancingProcessEmail,
      hasDelegatedPRE: formData.balancingProcessHasDelegatedPRE,
      hasOtherPRE: formData.balancingProcessHasOtherPRE,
      personName: formData.balancingProcessPersonName,
      personSurname: formData.balancingProcessPersonSurname,
      personCnp: formData.balancingProcessPersonCnp,
      preType: formData.balancingProcessPreType
    };

    return {
      id: this.userId,
      email: formData.email,
      aggregateDTO,
      balancingProcessDetailsDTO,
      clientDTO,
      personDTO,
      addressDTO,
      correspondenceAddressDTO,
      identityDocument: this.identityDocument
    };
  }

  errorNotification(message: string): void {
    Swal.fire({
      title: ' ',
      text: message,
      customClass: {
        popup: 'popup-z-elevate-24-blue'
      }
    });
  }

  onSubmit(): void {
    const invalidControls = Object.entries(this.accountForm.controls).filter(([key, control]) => {
      return !!control.invalid;
    });
    if (!this.accountForm.valid || this.identityDocument === null) {
      this.accountForm.markAllAsTouched();
      this.errorNotification('Nu toate campurile marcate cu steluta rosie au fost completate. Va rugam verificati');
      return;
    }

    if (this.userDetails) {
      this.userDetails = this.createDataFromForm();
      const personalData: FormData = new FormData();
      personalData.append('userDetails', JSON.stringify(this.userDetails));
      if (this.identityDocument.file) {
        personalData.append('identityDocument', this.identityDocument.file);
      }
      this.personalDataService.updatePersonalData(personalData).subscribe((value) => {
        this.toastrService.success('Date personale actualizate cu success.');
        this.reloadCurrentRoute();
      },
        error => {
          if (error && error.status === 409) {
            this.errorNotification(error.error.message);
          }
        }
      );
    }
  }

  reloadCurrentRoute(): void {
    const currentUrl = this.router.url;
    this.router.navigateByUrl('/', { skipLocationChange: true }).then(() => {
      this.router.navigate([currentUrl]);
    });
  }

  updateCorrespondenceCounty(value: any): void {
    if (this.isSameAddress) {
      this.accountForm.controls.correspondenceCounty.setValue(value);
    }
  }

  updateCorrespondenceCity(value: any): void {
    if (this.isSameAddress) {
      this.accountForm.controls.correspondenceCity.setValue(value);
    }
  }

  updateCorrespondenceStreetName(value: any): void {
    if (this.isSameAddress) {
      this.accountForm.controls.correspondenceStreetName.setValue(value);
    }
  }

  updateCorrespondenceStreetNumber(value: any): void {
    if (this.isSameAddress) {
      this.accountForm.controls.correspondenceStreetNumber.setValue(value);
    }
  }

  updateCorrespondenceBlock(value: any): void {
    if (this.isSameAddress) {
      this.accountForm.controls.correspondenceBlock.setValue(value);
    }
  }

  updateCorrespondenceFloor(value: any): void {
    if (this.isSameAddress) {
      this.accountForm.controls.correspondenceFloor.setValue(value);
    }
  }

  updateCorrespondenceApartment(value: any): void {
    if (this.isSameAddress) {
      this.accountForm.controls.correspondenceApartment.setValue(value);
    }
  }

  updateCorrespondencePostalCode(value: any): void {
    if (this.isSameAddress) {
      this.accountForm.controls.correspondencePostalCode.setValue(value);
    }
  }

  upload(fileList: FileList): void {
    console.log('upload', fileList);
    if (fileList.length > 0) {
      this.identityDocument = {
        fileName: fileList.item(0).name,
        fileByteSize: fileList.item(0).size,
        fileType: fileList.item(0).type,
        file: fileList.item(0)
      };
    }
  }

  onChangeCounty(): void {
    this.cities = [];
    if (this.isSameAddress) {
      this.citiesCorrespondence = [];
    }
    this.addressService.getCities(this.accountForm.get('county').value).subscribe(cities => {
      this.cities = cities;
      if (this.isSameAddress) {
        this.citiesCorrespondence = cities;
      }
    });
  }

  onChangeCountyCorrespondence(): void {
    this.citiesCorrespondence = [];
    this.addressService.getCities(this.accountForm.get('correspondenceCounty').value)
      .subscribe((citiesCorrespondence: CityDTO[]) => {
        this.citiesCorrespondence = citiesCorrespondence;
      });
  }

  ngOnDestroy(): void {
    for (const sub of this.subscriptions) {
      sub.unsubscribe();
    }
  }

  deleteDocument(): void {
    if (this.identityDocument) {
      this.identityDocument = null;
    }
  }

  get supplierWizzard(): string {
    return localStorage.getItem('fromSupplier');
  }

  get identificationDataLabel(): string {
    // return this.fromSupplier === true ? 'Date Identificare Client Final' : 'Date Identificare';
    return 'Date Identificare';
  }

  get isUninterruptibleLabel(): string {
    // return this.fromSupplier === true ? 'Clientul este neintreruptibil?' : 'Sunteți client neintreruptibil?';
    return 'Sunteți client neintreruptibil?';
  }

  get isVulnerableLabel(): string {
    // return this.fromSupplier === true ? 'Clientul este vulnerabil?' : 'Sunteți client vulnerabil?';
    return 'Sunteți client vulnerabil?';
  }

  get isProsumerLabel(): string {
    // return this.fromSupplier === true ? 'Clientul este prosumator?' : 'Sunteți prosumator?';
    return 'Sunteți prosumator?';
  }

  get isAutoSupplierLabel(): string {
    // return this.fromSupplier === true ? 'Clientul este autofurnizor?' : 'Sunteti autofurnizor?';
    return 'Sunteti autofurnizor?';
  }

  get isAgregateLabel(): string {
    // return this.fromSupplier === true ? 'Clientul face parte dintr-o agregare?' : 'Faceți parte dintr-o agregare?';
    return 'Faceți parte dintr-o agregare?';
  }

  get setHasDelegatedPRELabel(): string {
    // return this.fromSupplier === true ? 'Clientul a delegat responsabilitatea echilibrarii catre un PRE?' : 'Ati delegat responsabilitatea echilibrarii catre un PRE?';
    return 'Ati delegat responsabilitatea echilibrarii catre un PRE?';
  }

  get balancingProcessHasOtherPRELabel(): string {
    // return this.fromSupplier === true ? 'Clientul a delegat alt PRE?' : 'Aveti delegat alt PRE?';
    return 'Aveti delegat alt PRE?';
  }

}
